<template>
  <div class="investment_warp">
    <SearchHunt
      :filterData="filterData"
      @handle_seach="handle_seach"
      @handle_freeze="handle_freeze(selectedRows,1)"
      ref="SearchHunt"
    />
    <a-table
      class="antd-table"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange  , columnWidth: '50px'}"
      bordered
      :columns="relevanceBatch_grid.field"
      :data-source="relevanceBatch_grid.row"
      rowKey="id"
      size="small"
      :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
      :pagination="false"
      :loading="tableLoading"
    >
      <!-- 序号 -->
      <div slot="index" slot-scope="text, record, index">
        {{ index + (pageParam.pageNum - 1) * pageParam.pageSize + 1 }}
      </div>
      <!-- 订单状态 -->
      <span slot="orderStatus" slot-scope="text, record, index">
        <span v-if="record.orderStatus == '2'"><a-badge color="gold" /></span>
        <span v-else-if="record.orderStatus == '5' || record.orderStatus == '9'"><a-badge color="red"/></span>
        <span v-else><a-badge color="cyan" /></span>
        {{ text | DictionaryFilter("ORDER_STATUS") }}
      </span>
      
      <!-- 订单来源 -->
      <span slot="goodFrom" slot-scope="text, record">
        {{ text | DictionaryFilter("GOOD_FROM") }}
      </span>
      <!-- 更多操作 -->
      <span slot="operation" slot-scope="data" class="ellipsis">
         <!-- 待发货 -->
         <div v-if="data.orderStatus == '10'">
          <a @click="handle_freeze(data,2)">关闭</a>
          <a @click="handle_delivery(data)">发货</a>
        </div>
        <!-- 待打款 -->
        <div v-if="data.orderStatus == '2'">
          <a @click="handle_freeze(data,2)">关闭</a>
          <a @click="handle_view(data)">详情</a>
        </div>
         <!-- 已完成 -->
         <div v-else>
          <a @click="handle_view(data)">详情</a>
        </div>
      </span>
    </a-table>

    <!-- 底部 -->
    <div class="table_bottom">

      <!-- 分页 -->
      <div>
        <a-pagination
          class="table_pagination"
          show-size-changer
          :default-current="1"
          v-model="pageParam.pageNum"
          :show-total="(total) => `共 ${total} 条`"
          :page-size-options="pageSizeOptions"
          size="small"
          :total="total"
          @showSizeChange="onShowSizeChange"
          @change="paginationChange"
          :page-size.sync="pageParam.pageSize"
        />
      </div>
    </div>
    <!-- 审核 -->
    <examineModal
      v-if="examinelVisible" 
      :type="examineType"
      @close="close" 
      @handleOk="examineHandleOk"
    >
    </examineModal>
     <!-- 发货 -->
     <deliveryModal
      v-if="deliveryVisible" 
      :orderNo="deliveryOrderNo"
      @close="close" 
      @handleOk="deliveryHandleOk"
    >
    </deliveryModal>
  </div>
</template>

<script>
import {
  queryOrderList,
  handelOrder,
  batchConfirmOrder,
  updateLogistics
} from "@/api/api.js";
import moment from "moment";
import SearchHunt from "./components/search-hunt/search-hunt.vue";
import { DictionaryService } from "@common/services/dictionary.service";
import examineModal from "./components/modal-hunt/examineModal.vue";
import deliveryModal from "./components/modal-hunt/deliveryModal.vue";
export default {
  name: "",
  components: {
    SearchHunt,
    examineModal,
    deliveryModal
  },
  data() {
    return {
      //搜索栏
      filterData: [
        {
          name: "orderNo",
          type: "input",
          value: undefined,
          label: "请输入订单编号",
          placeholder:"订单编号：",
        },
        {
          name: "orderStatus",
          type: "select",
          value: undefined,
          label: "请选择订单状态",
          options: [],
          placeholder:"订单状态：",
        },
        {
          name: "commitDate",
          type: "date",
          value: undefined,
          label: "提交时间",
          placeholder:"提交时间：",
        },

      ],
      relevanceBatch_grid: {
        height: "calc(100vh - 250px)",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 55,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "订单编号",
            align: "center",
            width: 130,
            dataIndex: "orderNo",
            ellipsis: true,
          },
          {
            title: "订单状态",
            colSpan: 1,
            align: "center",
            width: 130,
            ellipsis: true,
            dataIndex: "orderStatus",
            scopedSlots: { customRender: "orderStatus" },
          },
          {
            title: "订单来源",
            colSpan: 1,
            align: "center",
            width: 130,
            ellipsis: true,
            dataIndex: "goodFrom",
            scopedSlots: { customRender: "goodFrom" },
          },
          {
            title: "商品名称",
            align: "center",
            width: 200,
            dataIndex: "goodName",
            ellipsis: true,
          },
          {
            title: "提交时间",
            align: "center",
            width: 160,
            dataIndex: "commitDate",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            width: 60,
            dataIndex: "orderNum",
            align: "center",
            ellipsis: true,
          },
          {
            title: "总金额",
            colSpan: 1,
            align: "center",
            width: 80,
            ellipsis: true,
            dataIndex: "orderAmount",
          },
          {
            title: "账户姓名",
            colSpan: 1,
            align: "center",
            width: 150,
            ellipsis: true,
            dataIndex: "accountName"
          },
          // {
          //   title: "备注",
          //   colSpan: 1,
          //   align: "center",
          //   width: 135,
          //   ellipsis: true,
          //   dataIndex: "remark"
          // },
          {
            title: "操作",
            width: 130,
            align: "center",
            scopedSlots: {
              customRender: "operation",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      selectedRowKeys: [],
      paramsObj: {
        orderNo: null,
        commitDate: null,
        orderStatus: null,
      },
      list: [],
      selectedRows: [],//多选数据

      //审核弹窗
      examinelVisible: false,
      examineType: "",
      examineData: [],

      //发货弹窗
      deliveryVisible: false,
      deliveryData: {},
      deliveryOrderNo:"",


      //查询加载
      tableLoading:false,
      
    };
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["ORDER_STATUS","GOOD_FROM"]).then((res) => {
      //订单状态
      this.filterData[1].options = DictionaryService.getOptions("ORDER_STATUS");

      //查询
      this.queryList();
    }); 
    // this.userTp = sessionStorage.getItem("usrTp");
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = data;
    },
    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      queryOrderList({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      })
      .then((res) => {
        if (res.content.rows && res.content.rows.length) {
          this.relevanceBatch_grid.row = res.content.rows;
          this.total = res.content.page.totalRows;
        } else {
          this.relevanceBatch_grid.row = [];
          this.total = 0;
        }
        this.tableLoading = false;
      }, (err) => {
        this.tableLoading = false;
      });
    },
    //退款
    handle_freeze(data,type) {
      // 1批量  2非批量
      if (type == 1) {
        if (this.selectedRowKeys && !this.selectedRowKeys.length) {
          return this.$message.warning("请先选中一条数据！");
        }
        //判断批量中是否存在不是待处理的数据
        for (let i = 0; i < this.selectedRows.length; i++){
          if (this.selectedRows[i].orderStatus !== '2') {
            return this.$message.warning("请选择订单状态为【待付款】的数据！");
          }
        }
        this.examineType = "1";
        this.examineData = this.selectedRows;
      } else {
        this.examineType = "2";
        this.examineData = data;
      }
      this.examinelVisible = true;
    },
    //详情
    handle_view(data) {
      this.$router.push({path:'/home/order-management/customer-orders/pages/operate',query:{orderNo:data.orderNo}})
    },
    //关闭弹窗
    close() {
      this.examinelVisible = false;
      this.deliveryVisible = false;
    },
    //确认弹窗
    examineHandleOk(data, type) {
      if (type == "1") {
        //批量接口
        let idList = [];
        this.examineData.forEach(item => {
          idList.push(item.id);
        })
        batchConfirmOrder({
          ids: idList,
          remark: data.reson,
          orderStatus: "4",  //关闭订单
        }).then(
          (res) => {
            if (res.code == '0000') {
              this.$message.success('操作成功！');
              this.queryList();
              this.selectedRowKeys = [];
              this.selectedRows = [];
            }
          },
          this.examinelVisible = false,
          this.examineData = [],
        );
      } else if (type == "2") {
        handelOrder({
          id: this.examineData.id,
          remark: data.reson,
          orderStatus: "4",  //关闭订单
        }).then(
          (res) => {
            if (res.code == '0000') {
              this.$message.success('操作成功！');
              this.queryList();
              this.selectedRowKeys = [];
              this.selectedRows = [];
            }
          },
          this.examinelVisible = false,
          this.examineData = [],
        );
      }
    },
    //发货
    handle_delivery(data) {
      this.deliveryVisible = true;
      this.deliveryOrderNo = data.orderNo;
    },
    //发货弹窗确认
    deliveryHandleOk(data,dataOne) {
      let req = {
        id: 0,
        logisticsComp: "",
        logisticsStatus: "",
        orderId: 0,
        waybillNum: ""
      };
      if (JSON.stringify(dataOne) != null) {
        req = { ...dataOne };
        req.logisticsStatus = "2";
        req.logisticsComp = data.logisticsComp;
        req.waybillNum = data.waybillNum;
      }
      updateLogistics(req)
      .then((res) => {
        this.$message.success('操作成功！');
        this.queryList();
        this.deliveryVisible = false;
      }, (err) => {
        this.$message.error('操作失败！');
        this.deliveryVisible = false;
      });
    },


  },
};
</script>

<style scoped lang="less">
.select_width {
  width: 180px !important;
}
.ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.investment_flex {
  display: flex;
  margin-bottom: 15px;
}
.investment_li {
  margin-right: 15px;
}
.custom {
  margin: 5px;
  color: #4093e1;
  cursor: pointer;
}
.table_pagination {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.box_warp {
  overflow-y: auto;
}
.end {
  justify-content: flex-end;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 10px 0px;
  margin-bottom: 20px;
  padding: 0 5px;
  border-left: 5px solid #0b2464;
}

.table_bottom{
  float: right;

  .bottom_btn{
    margin-top: 10px;
    flex: 1;

    .btn_first{
      margin-right: 10px;
    }
  }
}
</style>